// 계정 목록 페이지 나누기(account.ts 에서 옮김, account.ts 가 그대로 다시 내보낸다).
export const ADMIN_ACCOUNT_PAGE_SIZE = 25;

export interface AdminAccountPaginationSlice<T> {
  currentPage: number;
  pageCount: number;
  pageSize: number;
  startIndex: number;
  endIndex: number;
  items: T[];
}

export const paginateAdminAccountItems = <T>(
  items: T[],
  requestedPage: number,
  pageSize: number = ADMIN_ACCOUNT_PAGE_SIZE,
): AdminAccountPaginationSlice<T> => {
  const normalizedPageSize = Number.isFinite(pageSize) && pageSize > 0 ? Math.floor(pageSize) : ADMIN_ACCOUNT_PAGE_SIZE;
  const totalItems = items.length;
  const pageCount = Math.max(1, Math.ceil(totalItems / normalizedPageSize));
  const safeRequestedPage = Number.isFinite(requestedPage) ? Math.floor(requestedPage) : 1;
  const currentPage = Math.min(Math.max(safeRequestedPage, 1), pageCount);
  const offset = (currentPage - 1) * normalizedPageSize;
  const pageItems = items.slice(offset, offset + normalizedPageSize);

  return {
    currentPage,
    pageCount,
    pageSize: normalizedPageSize,
    startIndex: totalItems === 0 ? 0 : offset + 1,
    endIndex: totalItems === 0 ? 0 : offset + pageItems.length,
    items: pageItems,
  };
};
